import React from 'react';

import { Container } from './styles';

interface IStatusBadgeProps {
  status: 'Pendente' | 'Finalizado' | 'Cancelado';
}

const StatusBadge: React.FC<IStatusBadgeProps> = ({
  status,
}: IStatusBadgeProps) => {
  return <Container status={status}>{status}</Container>;
};

export default StatusBadge;
